<template>
    <div>
        <refresh :on-refresh="refresh" :refreshing="refreshing"></refresh>
        <loading :loading="loading"></loading>
        <Logo />
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6">
                <h3>My Messages</h3>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6" v-if="noMessages">
                You have not sent any messages.
            </div>
            <div class="col-11 col-xs-11 col-md-6" v-else>
                <!-- show all images -->
                <div v-for="message in messages" v-bind:key="message.id">
                    <ion-card color="primary">

                        <ion-card-header>
                            <ion-badge :style="statusColour(message.status)">{{statusText(message.status)}}</ion-badge>
                            <ion-card-subtitle>
                                {{dateFormat(message.send_at, 'Do MMMM YYYY')}}
                            </ion-card-subtitle>
                            <ion-card-title>
                                {{message.title}}
                            </ion-card-title>
                        </ion-card-header>
                        <ion-card-content>
                            <div v-if="message.type == 'text'">
                                <div v-html="nl2br(message.message)"></div>
                            </div>
                            <div v-else-if="message.status != 'processing' && message.status != 'uploaded'">
                                <div v-if="message.type =='audio'">
                                    <audio controls style="width:100%;">
                                        <source :src="message.path" :type="message.mime">
                                        Your browser does not support the audio tag.
                                    </audio>
                                </div>
                                <div v-else-if="message.type =='video'">
                                    <video controls style="width:100%;" poster="/img/icons/videos-blue.png">
                                        <source :src="message.path" :type="message.mime">
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                                <div v-else-if="message.type =='image'">
                                    <ion-img :src="message.path"></ion-img>
                                </div>
                            </div>
                            <hr>
                            <p v-for="recipient in message.recipients" v-bind:key="recipient.id">
                                {{recipient.name}} - {{recipient.email}}
                            </p>
                            <ion-button shape="round" expand="full" v-on:click="editMessage(message.id)" class="u-mt1" v-if="message.status == 'pending'">Edit</ion-button>
                        </ion-card-content>
                    </ion-card>
                </div>
            </div>
        </div>
        <ion-infinite-scroll @ionInfinite="loadMore" threshold="100px" position="bottom">
            <ion-infinite-scroll-content loading-spinner="dots"></ion-infinite-scroll-content>
        </ion-infinite-scroll>
       <return-home v-if="complete || noMessages"></return-home>
    </div>
</template>

<script>
import ReturnHome from '@/components/ReturnHome.vue'
import Refresh from '@/components/Refresh.vue'
import Loading from '@/components/Loading.vue'
import Logo from '@/components/Logo.vue'
import {auth} from '@/mixins/auth';
import {userdetails} from '@/mixins/userdetails';
import {formatting} from '@/mixins/formatting';
import _ from 'lodash';

export default {
    name: 'mymessages',
    components: {
        Logo, ReturnHome, Refresh, Loading
    },
    mounted : function () {
        this.showLoading();
        this.getMessages();
    },
    mixins : [auth, userdetails, formatting],
    data : function () {
        return {
            messages : [],
            page     : 1,
            complete : false,
            loading  : false,
            refreshing : false
        }
    },
    computed : {
        noMessages : function () {
            return _.size(this.messages) == 0;
        }
    },
    methods : {
        editMessage: function (id) {
            this.$router.push({name : 'editmessage', params : {id : id}})
        },
        showLoading : function () {
            this.loading = true;
        },
        hideLoading : function () {
            this.loading = false;
            this.refreshing = false;
        },
        loadMore : function (event) {
            // console.log('loading messages', event);
            this.getMessages();
            event.target.complete();
        },
        refresh : function () {
            this.refreshing = true;
            this.page = 1;
            this.getMessages();
        },
        getMessages : function () {
            let self = this;
            this.axios.get(this.api + 'messages?page=' + this.page)
                .then(response => {
                    if (self.refreshing) {
                        self.messages = [];
                        self.refreshing = false;
                    }
                    var messages = _.reverse(_.sortBy(response.data, ['send_at']));
                    self.hideLoading();
                    if (_.size(messages) > 0) {
                        _.each(messages, function (message) {
                            self.messages.push(message);
                        });
                        self.page = self.page + 1;
                    } else {
                        self.complete = true;
                    }
                })
                .catch(error => {
                    console.error('Error getting messages', error);
                    self.hideLoading();
                });
        },
        statusColour : function (status) {
            if (status == 'pending') {
                return '--background : var(--ion-color-primary); --color : var(--ion-color-primary-contrast);';
            }
            if (status == 'sent') {
                return '--background : var(--ion-color-success); --color : var(--ion-color-success-contrast);';
            }
            if (status == 'queued') {
                return '--background : var(--ion-color-warning); --color : var(--ion-color-warning-contrast);';
            }
            if (status == 'error') {
                return '--background : var(--ion-color-danger); --color : var(--ion-color-danger-contrast);';
            }
            if (status == 'new') {
                return '--background : var(--ion-color-dark); --color : var(--ion-color-dark-contrast);';
            }
            if (status == 'processing') {
                return '--background : var(--ion-color-medium); --color : var(--ion-color-medium-contrast);';
            }
            if (status == 'uploaded') {
                return '--background : var(--ion-color-medium); --color : var(--ion-color-medium-contrast);';
            }
        },
        statusText : function (status) {
            return _.startCase(status);
        }
    }
}
</script>

<style>
ion-badge {
    padding: 4px 12px;
    font-weight: 100;
}
</style>
